import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionPlanTranslate() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        planId: route.params.id,
        locale: null,
        title: '',
        description: '',
        hasData: false
    });

    const validations = {
        title: { required },
        locale: { required },
        description: {}
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => promotionService.plan.getText(model.planId, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
            model.description = data.description;
        },
        onError: ({ code }) => {
            if (code === ResponseCode.NothingFound) {
                model.hasData = false;
                model.title = '';
                model.description = '';
            } else router.push({ name: ROUTE_NAME_PROMOTION.PLAN.INDEX });
        },
        onFinally: () => v$.value.$reset()
    });

    const actions = {
        updateText: crudAction.excuteAndNotify({
            validator: v$,
            request: () => promotionService.plan.updateText(model.planId, model.locale, model.title, model.description),
            onSuccess: fetch
        }),
        removeText: crudAction.confirmAndRemove({
            request: () => promotionService.plan.removeText(model.planId, model.locale),
            onSuccess: fetch
        })
    };

    return { model, v$, fetch, beforeFetch, actions, localeSupportedOptions };
}
